import React from "react";
import { Button, Stack, alpha } from "@mui/material";
import {
  Refresh as RefreshIcon,
  ArrowBack as BackIcon,
  Assessment as ReportsIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import PageContentLayout from "../components/layout/PageContentLayout";
import WhatsAppReports from "../components/whatsapp/admin/WhatsAppReports";
import { crmColors } from "../theme/colors";

const WA = crmColors.whatsapp;
const WA_DARK = "#1DA851";

/**
 * Dedicated page — WhatsApp portfolio reports.
 */
const WhatsAppReportsPage = () => {
  const navigate = useNavigate();
  const [refreshKey, setRefreshKey] = React.useState(0);

  return (
    <PageContentLayout
      title="WhatsApp Reports"
      subtitle="Usage, revenue & quality across school WABAs"
      breadcrumbs={[
        {
          label: "WhatsApp Reports",
          icon: <ReportsIcon sx={{ color: "#ffffff", fontSize: 18 }} />,
        },
      ]}
      backTo="/whatsapp/accounts"
      actions={
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Button
            variant="outlined"
            size="small"
            startIcon={<BackIcon />}
            onClick={() => navigate("/whatsapp/accounts")}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: 600,
              borderColor: alpha(WA, 0.4),
              color: WA_DARK,
              "&:hover": { borderColor: WA, bgcolor: alpha(WA, 0.08) },
            }}
          >
            Accounts
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={<RefreshIcon />}
            onClick={() => setRefreshKey((k) => k + 1)}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: 600,
              borderColor: alpha(WA, 0.4),
              color: WA_DARK,
              "&:hover": { borderColor: WA, bgcolor: alpha(WA, 0.08) },
            }}
          >
            Refresh
          </Button>
        </Stack>
      }
    >
      <WhatsAppReports refreshSignal={refreshKey} />
    </PageContentLayout>
  );
};

export default WhatsAppReportsPage;
